import { useState, useEffect } from 'react';
// Firebase disabled - using WebSocket for real-time updates
// import { needsNotificationPermission, initFcm, unregisterFcm } from '@/lib/fcm';

export default function NotificationBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Firebase disabled - hide banner by default
    // Real-time notifications work via WebSocket when app is open
    const dismissed =
      localStorage.getItem('sb:notifications:dismissed') === 'true';
    // Commented out Firebase check
    // if (!dismissed && needsNotificationPermission()) {
    //   setVisible(true);
    // } else {
    //   setVisible(false);
    // }
    setVisible(false);
  }, []);

  if (!visible) return null;

  const onEnable = async () => {
    // Firebase disabled - using WebSocket for notifications
    // try {
    //   await initFcm();
    //   setVisible(false);
    // } catch (error) {
    //   console.warn('Failed to enable notifications:', error);
    //   setVisible(false);
    // }
    localStorage.setItem('sb:notifications:dismissed', 'true');
    setVisible(false);
  };

  const onDisable = async () => {
    // Firebase disabled
    // try {
    //   await unregisterFcm();
    // } finally {
    //   localStorage.setItem('sb:notifications:dismissed', 'true');
    //   setVisible(false);
    // }
    localStorage.setItem('sb:notifications:dismissed', 'true');
    setVisible(false);
  };

  return (
    <div className="w-full bg-blue-600 text-white text-sm px-4 py-2 flex items-center justify-between">
      <span>
        Enable notifications to get updates when tasks are assigned, approved,
        or when someone requests help.
      </span>
      <div className="flex items-center gap-2">
        <button
          className="bg-white text-blue-700 rounded px-3 py-1 font-medium"
          onClick={onEnable}
          aria-label="Enable notifications"
        >
          Enable
        </button>
        <button
          className="border border-white/70 rounded px-3 py-1"
          onClick={onDisable}
          aria-label="Disable notifications"
        >
          Not now
        </button>
      </div>
    </div>
  );
}
